import { useSelector } from "react-redux";

import useLogout from "@hooks/use-logout";

import { InternalButton } from "@sharedComponents/buttons";

import { getIsShopPrivate } from "@selectors/store";

import { BYSTADIUM_MARKETING_URL } from "@stadium/helpers/src/app-routes";

const AuthLogout = ({
  children,
  logoutUrl: logoutUrlFromProps,
  className = "",
  eventLocationAnalytics,
}) => {
  const isShopPrivate = useSelector(getIsShopPrivate);

  const logoutUrl = logoutUrlFromProps ?? (isShopPrivate ? BYSTADIUM_MARKETING_URL : "");

  const { logoutAction } = useLogout(logoutUrl);
  return (
    <InternalButton
      styleType="link"
      onClick={logoutAction}
      className={className}
      eventLocationAnalytics={eventLocationAnalytics}
    >
      {children}
    </InternalButton>
  );
};

export default AuthLogout;
